(function () {
  'use strict';

  var MIN_CROP = 0.24;
  var MAX_CROP = 1;
  var RESIZE_GAIN = 1.4;

  function clamp(v, lo, hi) { return Math.min(hi, Math.max(lo, v)); }

  function initBench(bench) {
    if (bench.dataset.lbReady) return;
    bench.dataset.lbReady = '1';

    var master  = bench.querySelector('[data-lb-master]');
    var frame   = bench.querySelector('[data-lb-frame]');
    var grip    = bench.querySelector('[data-lb-grip]');
    var hint    = bench.querySelector('[data-lb-hint]');
    var presets = Array.prototype.slice.call(bench.querySelectorAll('[data-lb-preset]'));
    if (!master || !frame || !grip) return;

    bench.classList.add('is-interactive');
    if (hint) hint.textContent = 'Drag to move · corner to resize';

    function readState() {
      var cs = getComputedStyle(bench);
      return {
        cx:   parseFloat(cs.getPropertyValue('--cx')) || 0,
        cy:   parseFloat(cs.getPropertyValue('--cy')) || 0,
        size: parseFloat(cs.getPropertyValue('--cs')) || 0.68
      };
    }

    function write(cx, cy, size) {
      size = clamp(size, MIN_CROP, MAX_CROP);
      cx = clamp(cx, 0, 1 - size);
      cy = clamp(cy, 0, 1 - size);
      bench.style.setProperty('--cx', cx.toFixed(4));
      bench.style.setProperty('--cy', cy.toFixed(4));
      bench.style.setProperty('--cs', size.toFixed(4));
    }

    function syncPresets(size) {
      presets.forEach(function (btn) {
        var on = Math.abs(parseFloat(btn.dataset.cs) - size) < 0.02;
        btn.classList.toggle('is-active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    var drag = null;

    function onMove(e) {
      if (!drag) return;
      e.preventDefault();
      var rect = master.getBoundingClientRect();
      var dx = (e.clientX - drag.px) / rect.width;
      var dy = (e.clientY - drag.py) / rect.height;
      if (drag.mode === 'move') {
        write(drag.cx + dx, drag.cy + dy, drag.size);
      } else {
        write(drag.cx, drag.cy, drag.size + Math.max(dx, dy) * RESIZE_GAIN);
      }
    }

    function onUp() {
      if (!drag) return;
      drag = null;
      bench.classList.remove('is-dragging');
      window.removeEventListener('pointermove', onMove);
      window.removeEventListener('pointerup', onUp);
      window.removeEventListener('pointercancel', onUp);
      syncPresets(readState().size);
    }

    function startDrag(mode, e) {
      if (e.button != null && e.button !== 0) return;
      e.preventDefault();
      var s = readState();
      drag = { mode: mode, px: e.clientX, py: e.clientY, cx: s.cx, cy: s.cy, size: s.size };
      bench.classList.add('is-dragging');
      window.addEventListener('pointermove', onMove, { passive: false });
      window.addEventListener('pointerup', onUp);
      window.addEventListener('pointercancel', onUp);
    }

    frame.addEventListener('pointerdown', function (e) {
      if (e.target === grip) return;
      startDrag('move', e);
    });
    grip.addEventListener('pointerdown', function (e) {
      e.stopPropagation();
      startDrag('resize', e);
    });

    presets.forEach(function (btn) {
      btn.disabled = false;
      btn.addEventListener('click', function () {
        var size = parseFloat(btn.dataset.cs);
        write(parseFloat(btn.dataset.cx), parseFloat(btn.dataset.cy), size);
        syncPresets(size);
        if (hint) hint.textContent = btn.textContent.trim() + ' · drag to adjust';
      });
    });

    syncPresets(readState().size);
  }

  function boot(root) {
    var benches = (root || document).querySelectorAll('[data-lb]');
    for (var i = 0; i < benches.length; i++) initBench(benches[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
